import { useState, useEffect, useRef } from "react";
import "../../styles/tombola.css";
import classNames from "classnames";
import { AnimatedLoader } from "../../components/utilities/loader-anim";


export const TicketSearch = () => {
    const numRef = useRef();

    const serverUrl = window.location.origin === "http://localhost:3000" ?
    "http://localhost/tombola" : "tombola"

    const [ticketNumber, setTicketNumber] = useState('');
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const isFilled = (v) =>{
        return ( v !== '' && v !== undefined && v !== null )
    };


    
    const submitTicket = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${serverUrl}/ticket?ticket_number=${ticketNumber}`,{
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                mode: "cors"
            });
            const res = await response.json();
            setUserData(res);
            
        } catch (error) {
            console.log({error});
        }finally{
            setIsLoading(false);
        }
    }

    return (
        <div className="cntr-page">
            {isLoading && <AnimatedLoader />}
            {!userData ? <form action="" className="reg-form">
                <div className="reg-caption">Search Tombola Entry</div>
                <div className="reg-input-container">
                    <label 
                        htmlFor="names" 
                        className={classNames("input-label",{'top': isFilled(ticketNumber)} )}
                    >
                       Ticket Number
                    </label>
                    <input
                        type="text"
                        className="reg-input"
                        id="ticketnumber"
                        required
                        ref={numRef}
                        onChange={(e) => {
                            e.preventDefault();
                            setTicketNumber(e.target.value);
                        }}
                    />
                </div>
                <div className="submit-button-box">
                    <button 
                        className="submit-reg"
                        onClick={async (e) => {
                            e.preventDefault();
                            await submitTicket();
                        }}
                    >
                        Submit
                    </button>
                </div>
            </form> :
            <div className="user-info">
                <div className="name-value" id="name-val">{userData?.user?.names}</div>
                <div className="num-value" id="num-val">{userData?.user?.ticket_number}</div>
            </div>}
        </div>
    )
}